<!-- <mat-list>
  <ng-container *ngFor="let message of messages">
    <mat-divider></mat-divider>
    <mat-list-item [ngClass]="{ unseen: message.unseen }">
      <div mat-line>
        <div>
          <div>
            <span
              >From: {{ message.from }} <span *ngIf="message.unseen">(Unseen)</span></span
            >
            <span *ngIf="message.to">To: {{ message.to }} </span>
          </div>
          <span>{{ message.sentFormatted }}</span>
        </div>
      </div>
      <div mat-line>
        <div>
          <span>{{ message.body }}</span>
          <span
            class="unseen-visual-indicator"
            *ngIf="message.unseen !== undefined"
          ></span>
        </div>
      </div>
    </mat-list-item>
  </ng-container>
</mat-list> -->

<mat-list>
  <ng-container *ngFor="let message of messages">
    <mat-divider></mat-divider>
    <mat-list-item [ngClass]="{ unseen: message.unseen }">
      
      <div class="message-header-line">
        <div class="message-header-content">
          <div class="from-to-block">
            <span class="from-field">
              From: {{ message.from }} <span *ngIf="message.unseen">(Unseen)</span>
            </span>
            <span class="to-field" *ngIf="message.to">To: {{ message.to }} </span>
          </div>
          <span class="sent-time">{{ message.sentFormatted }}</span>
        </div>
      </div>
      
      <div class="message-body-line">
        <div class="message-body-content">
          <span class="body-text">{{ message.body }}</span>
          <span
            class="unseen-visual-indicator"
            *ngIf="message.unseen !== undefined"
          ></span>
        </div>
      </div>
      
    </mat-list-item>
  </ng-container>
</mat-list>
